import React from 'react'
import "./styles/Ayuda.scss"
import { useState } from 'react';
import { Input, Row, Button, Layout, Modal, Empty, } from "antd";
import Typography from "@mui/material/Typography";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, Stack } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Tutoriales from './Tutoriales';
import { WhatsApp } from '@mui/icons-material';
import { WhatsAppChatURL } from '../services/apiUrl';
import NewNavbar from '../componentes/GeneralComponents/Navbar_Nuevo';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Ayuda() {

  const location = useLocation();

  const listQuestions = [
    {
      "id": '0',
      "question": '¿Qué es Ygia?',
      "answer":
        "YGIA MEDICAL es una plataforma digital , con poderosas herramientas para facilitar a profesionales de la salud (médicos, dentista, nutriólogos, terapeutas …) la gestión de sus consultas, expedientes médicos, y la conexión con sus pacientes a través de la plataforma.",
    },
    {
      "id": '1',
      "question": '¿Cuáles son las principales funciones?',
      "answer":
        "Nuestra plataforma ofrece un expediente clínico digital para cada paciente, herramientas para gestionar consultas, estudios, agenda médica. Realizar la receta digital, realizar cobros y facturación a pacientes. Cuenta con perfil tipo Asistente médico.",
    },
    {
      "id": '2',
      "question": '¿Ygia es seguro?',
      "answer":
        "En Ygia nos preocupamos por la seguridad de tu información y la de tus pacientes, por ello nos apegamos a la certificación HIPPA, al Nivel 1 como Proveedor de Servicios PCI y a la Norma Oficial Mexicana NOM-004-SSA3-2012, del expediente clínico.",
    },
    {
      "id": '3',
      "question": '¿Cómo está respaldada la información?',
      "answer":
        "Toda la información se almacena en la nube, respaldada por uno de los proveedores líderes a nivel mundial de servicios en la nube. La plataforma implementa tres capas de seguridad para proteger los datos de manera integral.",
    },
    {
      "id": '4',
      "question": '¿Cuál es la capacidad de almacenamiento?',
      "answer":
        "Dependiendo del plan contratado, la capacidad varía de 3 GB (membresía Freemium) a 50 GB (Plan Ygia Superior). Si necesitas espacio adicional, puedes consultar y contratar expansiones desde el módulo de Mi suscripción (ve al menú de Perfil -> menú de Cartera).",
    },
    {
      "id": '5',
      "question": '¿Se puede usar en cualquier dispositivo?',
      "answer":
        "Sí. La plataforma es compatible con cualquier computadora o dispositivo inteligente que utilice la versión más reciente de Google Chrome, Safari o Firefox.",
    },
    {
      "id": '6',
      "question": '¿Cómo me registro en Ygia?',
      "answer": <div>Para registrarte es necesario dirigirse al apartado <a href="https://ygia.app/#/registrarme">Registrarme</a>.</div>,
    },
    // {
    //   "id": '7',
    //   "question": '¿Qué necesito para poder usar Ygia?',
    //   "answer":
    //     "Solo necesitas contar con internet y un dispositivo con la versión más reciente de Google Chrome, Safari, Firefox, iOS o Android.",
    // },
    {
      "id": '8',
      "question":
        '¿Qué hago si por algún incidente, robo, extravío u otro mi información está en riesgo?',
      "answer": <div>Puedes comunicarte con soporte técnico a nuestro WhatsApp <IconButton target='_blank' href='https://wa.me/message/P2CQCNCUDX5RG1' children={<WhatsApp sx={{ fontSize: 20, color: "green" }} />} /> o al correo soporte@ygia.app.</div>,
    },
    {
      "id": '9',
      "question":
        'Olvidé mis datos de inicio de sesión, ¿Puedo recuperar mi cuenta?',
      "answer": <div>Puedes recuperar tu contraseña desde el apartado <a href="https://ygia.app/#/recuperacion">Recuperar</a>.</div>,
    },
    {
      "id": '10',
      "question": '¿Puedo cancelar mi cuenta?',
      "answer":
        "Si, desde el módulo de Mi suscripción (ve al menú de Perfil -> menú de Cartera).",
    },
    {
      "id": '11',
      "question": 'Si cancelo mi cuenta, ¿Cómo recupero mi información?',
      "answer": <div>Puedes comunicarte con soporte técnico a nuestro WhatsApp <IconButton target='_blank' href='https://wa.me/message/P2CQCNCUDX5RG1' children={<WhatsApp sx={{ fontSize: 20, color: "green" }} />} /> o al correo soporte@ygia.app.</div>,
    },
    {
      "id": '12',
      "question": '¿A dónde me puedo comunicar si tengo algún problema?',
      "answer": <div>Puedes comunicarte con soporte técnico a nuestro WhatsApp <IconButton target='_blank' href='https://wa.me/message/P2CQCNCUDX5RG1' children={<WhatsApp sx={{ fontSize: 20, color: "green" }} />} /> o al correo soporte@ygia.app.</div>,
    },
    {
      "id": '13',
      "question": '¿Cuál es el precio del servicio Ygia?',
      "answer":
        "Ygia para médicos tiene un costo base de \$599 MXN mensuales. Ygia App para pacientes es totalmente gratuita",
    },
    {
      "id": '14',
      "question": '¿Cuáles son las formas de pago?',
      "answer":
        "Puedes realizar pagos con cualquier tarjeta Visa o Mastercard.",
    },
    {
      "id": '15',
      "question":
        '¿Ygia cuenta con un periodo de prueba antes de adquirir la suscripción?',
      "answer":
        "Cuenta con un periodo de 15 días para probar todas las funcionalidades de Ygia totalmente gratis.",
    },
    {
      "id": '16',
      "question": '¿Aumenta el precio si uso Ygia en más de un consultorio?',
      "answer":
        "Puedes utilizar Ygia médicos en 2 dispositivos a la vez.",
    },
    {
      "id": '17',
      "question": '¿La aplicación móvil tiene un costo adicional?',
      "answer":
        "La aplicación móvil no tiene costo extra.",
    },
    {
      "id": '18',
      "question": '¿Cómo se realiza el cobro de mi suscripción?',
      "answer":
        "El cobro se realiza automáticamente cada mes a tu tarjeta Visa o Mastercard registrada.",
    },
    {
      "id": '19',
      "question": '¿Es seguro realizar pagos con Ygia?',
      "answer":
        "Todos los pagos realizados a través de Ygia son controlados por Stripe. Proveedor certificado de Servicios PCI DSS, con el nivel más riguroso existente dentro de la industria de pagos.",
    },
    {
      "id": '20',
      "question": '¿Tengo algún tipo de garantía al adquirir mi plan?',
      "answer":
        "Ygia cuenta con un periodo de prueba de 15 días, dentro del cual podrás disfrutar de todas sus características totalmente gratis para evitar este tipo de situaciones. Si el software no te convence después de haber hecho tu compra, te devolvemos tu dinero, hasta 7 días después de tu compra.",
    },
    {
      "id": '21',
      "question": '¿Es necesario registrar una tarjeta?',
      "answer":
        "No es necesario registrar alguna tarjeta para utilizar el periodo de prueba de 15 días, pero será necesaria para adquiri Plan Ygia Superior, una vez terminado el periodo de prueba.",
    },
  ];
  const { Header, Content, Footer } = Layout;

  const [TabsAyuda, setTabsAyuda] = useState("1");

  const [videos, setvideos] = useState([
    {

      id: "1",
      videoUrl: "https://www.youtube.com/watch?v=_Rj0LrcV84Q",
      titleVideo: "Conoce Ygia",
      descripcion: "Lleva tu practica médica al siguiente nivel con las herramientas de nuestra plataforma.",
    },
    {

      id: "2",
      videoUrl: "https://www.youtube.com/watch?v=E9THuazolLw",
      titleVideo: "¿Cómo registrarme en YGIA?",
      descripcion: "¿Listo para llevar tu consulta médica al siguiente nivel? En este video te mostramos paso a paso cómo registrarte en YGIA.",
    },
    {
      id: "3",
      videoUrl: "https://www.youtube.com/watch?v=am_S6SDVB6o",
      titleVideo: "¿Cómo configurar mi receta en YGIA?",
      descripcion: "¿Quieres prescribir recetas de forma digital y profesional desde YGIA? En este video te explicamos paso a paso cómo configurar la información que aparecerá en tus recetas.",
    },
    {
      id: "4",
      videoUrl: "https://www.youtube.com/watch?v=JMmlkO6Mjz0",
      titleVideo: "¿Cómo configurar mi horario de citas en YGIA?",
      descripcion: "¿Quieres tener el control total de tu agenda médica? En este tutorial te mostramos cómo configurar paso a paso tu horario de citas en YGIA.",
    },

  ]);

  const [videosFilter, setvideosFilter] = useState([
    {

      id: "1",
      videoUrl: "https://www.youtube.com/embed/Z1_pcApgPX0?si=SyUaBAlsfVt2CjQF",
      titleVideo: "Configuraciones generales de Ygia",
      descripcion: "En este módulo aprenderás lo necesario para configurar tus horarios de citas, formatos para recetas y agregar una nueva cedula profesional.",
    },
    {

      id: "2",
      videoUrl: "https://www.youtube.com/embed/2EtstAQwG7I?si=p5FLFktuVG61s2jJ",
      titleVideo: "¿Cómo agendar una cita medica?",
      descripcion: "En este tutorial aprenderas cómo agendar una cita, agregar mi primer paciente y Tipos de pacientes que existen.",
    },
    {
      id: "3",
      videoUrl: "https://www.youtube.com/embed/KTX6Yu5TpXQ?si=o3_VO-djr_l_72lA",
      titleVideo: "¿Cómo hacer una consulta medica?",
      descripcion: "En este modulo aprenderas a cómo  crear tu primara consulta y reseta en Ygia.",
    },
    {
      id: "4",
      videoUrl: "https://www.youtube.com/embed/eZLIfSrBYJs?si=LS_t3bGXqoeVx1Gm",
      titleVideo: "¿Cómo visualizo y modifico mi Expediente?",
      descripcion: "En este modulo aprenderas a buscar el expediente de un paciente y modificar su contenido.",
    },

  ]);

  function filterList(text) {
    var chars = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      à: "a",
      è: "e",
      ì: "i",
      ò: "o",
      ù: "u",
      ñ: "n",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      À: "A",
      È: "E",
      Ì: "I",
      Ò: "O",
      Ù: "U",
      Ñ: "N",
    };
    var expr = /[áàéèíìóòúùñ]/gi;

    let filterVideos = [];
    videosFilter.forEach((video) => {
      if (
        video.titleVideo.replace(expr, function (e) {
          return chars[e];
        })
          .toLowerCase()
          .indexOf(
            text.target.value
              .replace(expr, function (e) {
                return chars[e];
              })
              .toLowerCase()
          ) > -1 ||
        video.descripcion.replace(expr, function (e) {
          return chars[e];
        })
          .toLowerCase()
          .indexOf(
            text.target.value
              .replace(expr, function (e) {
                return chars[e];
              })
              .toLowerCase()
          ) > -1
      ) {
        filterVideos.push(video);
      }
    });

    setvideos(filterVideos);
  }

  // MANEJA DE MENSAJES
  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (location.state) {
      if (location.state.tab) {
        setTabsAyuda(location.state.tab);
      }
    }
  }, [])


  return (
    <Stack>
      <NewNavbar
        showBanner={false}
        mensajesError={{
          setOpen: setOpen,
          setTypeMessage: setTypeMessage,
          setMessage: setMessage,
        }}

        searchBar={
          <div style={{ width: "100%" }}>
            <div className="tabsContainer">
              <div
                className={
                  TabsAyuda === "1" ? "tabsAyuda active_tabs" : "tabsAyuda"
                }
                onClick={() => setTabsAyuda("1")}
              >
                <p>Preguntas frecuentes</p>
              </div>

              <div
                className={
                  TabsAyuda === "2" ? "tabsAyuda active_tabs" : "tabsAyuda"
                }
                onClick={() => setTabsAyuda("2")}
              >
                Tutoriales
              </div>

              <div
                className={
                  TabsAyuda === "3" ? "tabsAyuda active_tabs" : "tabsAyuda"
                }
                onClick={() => setTabsAyuda("3")}
              >
                Soporte
              </div>

            </div>
            {TabsAyuda === "2" && (
              <div style={{ width: "100%", background: "white", padding: "15px" }}>
                <Input
                  className="inputsearchtutoriales"
                  placeholder="Buscar..."
                  type="text"
                  // style={{ width: "31%", marginBottom: "10px", marginLeft: "10px" }}
                  onChange={filterList}
                />
              </div>
            )}
          </div>
        }
      />
      {TabsAyuda === "1" && (
        <div style={{ padding: "1px 3%" }}>
          {listQuestions.map((question) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography><b style={{ color: "#464646" }}>{question.question}</b></Typography>

              </AccordionSummary>
              <AccordionDetails>
                <div>
                  {question.answer}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      )}

      {TabsAyuda === "2" && (
        <Tutoriales videos={videos} />
      )}

      {TabsAyuda === "3" && (
        <div className='soporteContent'>
          <div style={{ width: "50%", background: "white", padding: "10px", textAlign: "center" }}>
            <div style={{ marginTop: "10px" }}>
              <b>WhatsApp de soporte:</b>
              {/* <p>https://wa.me/message/P2CQCNCUDX5RG1</p> */}
              <div>
                <IconButton target='_blank' href={WhatsAppChatURL} children={<WhatsApp sx={{ fontSize: 40, color: "green" }} />} />
              </div>
              {/* <div style={{width:"50%"}}>
                <a href="https://wa.me/message/P2CQCNCUDX5RG1" target='_blank' ><WhatsApp/></a>
              </div> */}
            </div>
            <div style={{ marginTop: "20px", marginBottom: "10px" }}>
              <b>Correo de soporte:</b>
              <p>soporte@ygia.app</p>
            </div>
          </div>
        </div>
      )}
    </Stack>
  )
}

export default Ayuda